import { ReactNode, Fragment, useMemo } from "react";
import Box from "@mui/material/Box";
import useJStyles from "$hooks/useJStyles";
import { DatableWithoutContext, DataTableProvider } from "..";
import { DataTableProps } from "../DataTable.type";

interface DataTableWithContextProps extends DataTableProps {
  externalState?: any; // TODO this should be a partial of initialstate
  buttonList?: ReactNode[];
  filterList?: ReactNode[];
}

/**
 *
 * @param externalState /!\ if you don't give this param with a useMemo, it will rerender indefinitely
 * @returns
 */
export const DataTableWithContext = ({
  externalState = {},
  buttonList,
  filterList,
  ...rest
}: DataTableWithContextProps) => {
  const { jclasses } = useJStyles();

  const externalInfo = useMemo(
    () => (
      <Box className={jclasses.jBeforePaper}>
        {filterList?.map((Components, i) => (
          <Fragment key={`${i}`}>{Components}</Fragment>
        ))}
        {buttonList?.map((Components, i) => (
          <Fragment key={`${i}`}>{Components}</Fragment>
        ))}
      </Box>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [filterList]
  );

  return (
    <DataTableProvider externalState={externalState}>
      {externalInfo}
      <DatableWithoutContext {...rest} />
    </DataTableProvider>
  );
};
